import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Printer, Settings, Package, Truck } from 'lucide-react';

const WhyUs = () => {
  const { t } = useLanguage();

  const icons = [Printer, Settings, Package, Truck];

  return (
    <section id="capabilities" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {t.whyUs.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {t.whyUs.features.map((feature, index) => {
            const Icon = icons[index];
            return (
              <div
                key={index}
                className="group relative bg-gradient-to-br from-gray-50 to-blue-50/30 rounded-2xl p-8 border border-gray-200 hover:border-[#1c3855] hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="mb-6">
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-[#1c3855] text-white group-hover:scale-110 transition-transform">
                    <Icon className="h-7 w-7" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
